/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-restricted-globals */
/* eslint-disable camelcase */
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faCheck } from "@fortawesome/free-solid-svg-icons";
import PropTypes from "prop-types";
import { Box, DialogContent, Typography, Button, Alert, TextField, Checkbox } from "@mui/material";
import Modal from "../Modal/Modal";
import withStepper from "../Modal/withStepper";
import { addToast as addToastAction } from "../../actions/toasts";

import {
  updateChannelTier as updateChannelTierAction
} from "../../actions/channel_tiers";
import { showChannelTier } from "../../selectors/channel_tiers";

const initialState = {
  name: "",
  is_channel_logo_optional: false,
  is_epg_description_optional: false,
  is_epg_logo_optional: false,
  min_epg_duration: 0,
};

class EditChannelTierModal extends PureComponent {
  constructor(props) {
    super(props);

    let state = { ...initialState };

    if (props.channelTier) {
      const {
        name,
        is_channel_logo_optional,
        is_epg_description_optional,
        is_epg_logo_optional,
        min_epg_duration
      } = props.channelTier;

      state = {
        ...state,
        name,
        is_channel_logo_optional,
        is_epg_description_optional,
        is_epg_logo_optional,
        min_epg_duration
      };
    }

    this.state = { ...state };
  }

  componentDidUpdate(prevProps) {
    const { channelTier } = this.props;

    if (prevProps.channelTier !== channelTier && channelTier !== null) {
      const {
        name,
        is_channel_logo_optional,
        is_epg_description_optional,
        is_epg_logo_optional,
        min_epg_duration
      } = channelTier;

      this.setState({
        name,
        is_channel_logo_optional,
        is_epg_description_optional,
        is_epg_logo_optional,
        min_epg_duration
      });
    }
  }

  changeInput(inputName, event) {
    const { value } = event.target;

    this.setState(() => ({ [inputName]: value }));
  }

  toggleInput(inputName) {
    const { [inputName]: inputValue } = this.state;

    this.setState({ [inputName]: !inputValue });
  }

  async editChannelTier() {
    const { currentId, updateChannelTier, addToast } = this.props;

    const {
      name,
      is_channel_logo_optional,
      is_epg_description_optional,
      is_epg_logo_optional,
      min_epg_duration
    } = this.state;

    const ret = await updateChannelTier(currentId, {
      name,
      is_channel_logo_optional,
      is_epg_description_optional,
      is_epg_logo_optional,
      min_epg_duration: parseInt(min_epg_duration, 10)
    });

    if (ret.isSuccess) {
      addToast("success", "Success", "Channel Tier successfully updated!");
      this.closeModal();
    } else {
      addToast("error", "Error", "Error while updating Channel Tier. Try again.");
    }
  }

  closeModal() {
    const { closeEditModal } = this.props;

    this.setState(initialState);
    closeEditModal();
  }

  minEpgDurationIsValid() {
    const { min_epg_duration } = this.state;

    if (!min_epg_duration) {
      return false;
    }
    if (parseInt(min_epg_duration, 10) <= 0) {
      return false;
    }
    return true;
  }

  modalContent() {
    const {
      name,
      is_channel_logo_optional,
      is_epg_description_optional,
      is_epg_logo_optional,
      min_epg_duration
    } = this.state;

    const { isLastStep, stepperComponent } = this.props;

    return (
      <DialogContent sx={{ display: "flex", gap: 3, flexDirection: "column", marginTop: 1, width: "80%", alignItems: "center", alignSelf: "center" }}>
        {stepperComponent}
        <Box sx={{ alignItems: "flex-start", display: "flex", flexDirection: "column", gap: 3, width: "100%" }}>
          {!name && <Alert severity="error">Name is not valid</Alert>}
          <TextField error={!name} inputProps={{ readOnly: isLastStep }} label="Name" value={name} onChange={() => this.setState({ name: event.target.value })}/>
          <Box sx={{ display: "flex", alignItems: "center", cursor: !isLastStep && "pointer" }}
            onClick={() => {
              if (!isLastStep) {
                this.toggleInput("is_channel_logo_optional");
              }
            }}>
            <Box sx={{ width: "50px", height: "50px", display: "flex", alignItems: "center", justifyContent: "center" }}>
              {!isLastStep
                ? <Checkbox sx={{ padding: 0, margin: 0 }} checked={is_channel_logo_optional}/>
                : <FontAwesomeIcon icon={is_channel_logo_optional ? faCheck : faXmark} size="xl"/>
              }
            </Box>
            <Typography sx={{ userSelect: "none" }} >Is channel logo optional ?</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", cursor: !isLastStep && "pointer" }}
            onClick={() => {
              if (!isLastStep) {
                this.toggleInput("is_epg_logo_optional");
              }
            }}>
            <Box sx={{ width: "50px", height: "50px", display: "flex", alignItems: "center", justifyContent: "center" }}>
              {!isLastStep
                ? <Checkbox sx={{ padding: 0, margin: 0 }} checked={is_epg_logo_optional}/>
                : <FontAwesomeIcon icon={is_epg_logo_optional ? faCheck : faXmark} size="xl"/>
              }
            </Box>
            <Typography sx={{ userSelect: "none" }} >Is EPG logo optional ?</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", cursor: !isLastStep && "pointer" }}
            onClick={() => {
              if (!isLastStep) {
                this.toggleInput("is_epg_description_optional");
              }
            }}>
            <Box sx={{ width: "50px", height: "50px", display: "flex", alignItems: "center", justifyContent: "center" }}>
              {!isLastStep
                ? <Checkbox sx={{ padding: 0, margin: 0 }} checked={is_epg_description_optional}/>
                : <FontAwesomeIcon icon={is_epg_description_optional ? faCheck : faXmark} size="xl"/>
              }
            </Box>
            <Typography sx={{ userSelect: "none" }} >Is EPG description optional ?</Typography>
          </Box>
          {!this.minEpgDurationIsValid() && <Alert severity="error">Min. EPG Duration must is not valid</Alert>}
          <TextField sx={{ width: "40%" }} error={!this.minEpgDurationIsValid()} inputProps={{ readOnly: isLastStep }} type="number" label="Minimum EPG Duration * (in seconds)" value={min_epg_duration} onChange={() => this.setState({ min_epg_duration: event.target.value })}/>
        </Box>
      </DialogContent>
    );
  }

  modalActions() {
    const { name } = this.state;
    const { currentStep, previousStep, nextStep, isLastStep } = this.props;

    return (
      [
        <Button variant="outlined"
          key="cancel"
          onClick={() => {
            this.closeModal();
          }} >
            Cancel
        </Button>,
        currentStep > 0 && <Button variant="outlined"
          key="previous"
          onClick={() => {
            previousStep();
          }}>
            Previous
        </Button>,
        !isLastStep && <Button variant="contained"
          key="next"
          disabled={!this.minEpgDurationIsValid() || !name }
          color="secondary"
          onClick={() => {
            nextStep();
          }}>
            Next
        </Button>,
        isLastStep && <Button variant="contained"
          key="save"
          color="secondary"
          onClick={() => {
            this.editChannelTier();
          }}>
            Save
        </Button>
      ]
    );
  }

  render() {
    const {
      modalOpened,
      channelTier,
    } = this.props;

    return (
      <Modal
        isOpen={modalOpened}
        title={"Edit channel tier " + channelTier.name || ""}
        customModalContent={() => this.modalContent()}
        closeModal={() => this.closeModal()}
        actions={() => this.modalActions()}
        actionAlign="flex-end"
      />
    );
  }
}

EditChannelTierModal.defaultProps = {
  currentId: null
};

EditChannelTierModal.propTypes = {
  currentId: PropTypes.number,

  channelTier: PropTypes.object.isRequired,

  modalOpened: PropTypes.bool.isRequired,

  closeEditModal: PropTypes.func.isRequired,
  currentStep: PropTypes.number,
  previousStep: PropTypes.func,
  nextStep: PropTypes.func,
  isLastStep: PropTypes.bool,
  stepperComponent: PropTypes.object,

  updateChannelTier: PropTypes.func.isRequired,
  addToast: PropTypes.func.isRequired
};

function mapStateToProps(state, ownProps) {
  return {
    channelTier: showChannelTier(state, ownProps.currentId) || {}
  };
}

const mapDispatchToProps = {
  updateChannelTier: updateChannelTierAction,
  addToast: addToastAction
};

export default connect(mapStateToProps, mapDispatchToProps)(withStepper(
  EditChannelTierModal, [
    "Set channel tier information",
    "Sumup"
  ]));
